module.exports = __webpack_public_path__ + "static/media/jin_default193ba329d43c823711296811f71ae7a2.webp";